class Commands {
    key;
    registry;

    constructor(key, registry) {
        this.key = key;
        this.registry = registry
    }

    async execute(node, emitter, options) {
        throw "Subclass responsibility";
    }

    compareByKey(otherKey) {
        return this.key.toUpperCase() === otherKey?.toUpperCase();
    }
}

export default Commands;
